
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11498',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11498",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.213",
  "data-fetching-client": "static-1.9456",
  "foundations-components": "static-1.7483",
  "foundations-components-legacy": "static-1.508",
  "foundations-theming": "static-1.4187",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7783",
  "hub-http-shared-msw-handlers": "static-1.9429",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11201",
  "I18n": "static-7.1562",
  "jasmine-runner": "static-1.6250",
  "marketplace-storefront-base": "static-1.11558",
  "quartz": "static-1.6694",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16419",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2640",
  "reporting-testing-lib": "static-1.8363",
  "settings-ui-lib": "static-1.12298",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6685",
  "ui-addon-i18n": "static-1.10910",
  "ui-addon-react-router-dom": "static-1.9326",
  "unified-auth": "static-1.173",
  "unified-auth-core-lib": "static-1.454",
  "usage-tracker": "static-1.7110",
  "usage-tracker-core": "static-1.6960",
  "customer-data-property-utils": "static-1.7849",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15354",
  "marketplace-ui-common": "static-1.18879",
  "property-management-iframe": "static-1.12241",
  "quartz-config": "static-1.472",
  "quartz-core": "static-1.5913",
  "quartz-routing": "static-1.124",
  "quick-fetch": "static-1.3713",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4410",
  "ts-schema": "static-1.3884",
  "ui-universal-auth": "static-1.8659",
  "UIComponents": "static-3.8148",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3208",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2971",
  "quartz-webpack": "static-1.2918",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3752",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4611",
  "foundations-theming-specialty": "static-1.1903",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9206",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5153",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1127",
  "ui-fonts": "static-1.463",
  "ui-images": "static-2.1085",
  "bend-plugin-foundations-theming": "static-1.2670",
  "foundations-theming-base": "static-1.3172",
  "stylex": "static-1.27",
  "HeadJS": "static-2.704",
  "hs-test-utils-bend-plugin": "static-1.2894",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4107",
  "ai-components-ui-library": "static-1.8294",
  "ai-rendering-library": "static-1.9236",
  "chirp-fetch": "static-1.1662",
  "connections-embed-lib": "static-1.592",
  "copilot-toolkit": "static-1.10468",
  "laboratory-lib": "static-3.6940",
  "marketplace-embed": "static-1.21430",
  "marketplace-ui-details": "static-1.8775",
  "marketplace-ui-reviews": "static-1.18835",
  "marketplace-ui-tracking": "static-1.13050",
  "sanitize-text": "static-1.7918",
  "ui-addon-video-player": "static-1.8474",
  "usage-tracker-multi": "static-1.5524",
  "usage-tracker-session-replay": "static-1.4796",
  "wootric-nps": "static-1.6760",
  "apollo-link-hub-http": "static-2.4426",
  "immer": "static-1.33",
  "immerable": "static-1.3932",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2382",
  "reporting-data": "static-1.66430",
  "cssUtils": "static-1.725",
  "flux-actions": "static-1.304",
  "HubStyle": "static-2.11509",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9989",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10150",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7100",
  "icons": "static-2.618",
  "marketplace-ui-apps-core": "static-1.17412",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4301",
  "foundations-components-test-utils": "static-1.4966",
  "quartz-i18n": "static-1.369",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3509",
  "customer-data-objects": "static-1.7422",
  "property-translator": "static-1.5191",
  "frontend-preferences-client": "static-1.7702",
  "hs-promise-utils": "static-1.5369",
  "hubspot-apollo-client": "static-1.4657",
  "integrations-error-boundary-lib": "static-1.12769",
  "integrations-tracking-lib": "static-1.5363",
  "native-integrations-shared-strings": "static-1.7566",
  "reselect": "static-2.16",
  "sanitize": "static-1.4252",
  "superstore": "static-1.4549",
  "ui-shepherd-react": "static-3.9922",
  "ai-settings-ui-library": "static-1.7382",
  "hub-http-janus": "static-1.787",
  "hubspotter-http": "static-1.4457",
  "immutable-less": "static-1.4431",
  "marketplace-ui-client-types": "static-1.16286",
  "nav-meta": "static-1.28842",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10014",
  "ui-addon-upgrades": "static-9.17618",
  "inbound-db-properties-service-client": "static-1.3655",
  "property-management-common": "static-1.4528",
  "ui-addon-iframeable": "static-1.8819",
  "dispatcher": "static-1.131",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.369",
  "quartz-head": "static-1.359",
  "quartz-test": "static-1.369",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2921",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20225",
  "ContentUtils": "static-1.67562",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2263",
  "customer-data-filters-ui": "static-1.38822",
  "customer-data-objects-ui-components": "static-1.12782",
  "customer-data-reference-ui-components": "static-1.12919",
  "embedded-academy-lib": "static-1.13429",
  "ExportDialog": "static-6.10166",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40608",
  "reporting-snowflake": "static-1.55048",
  "reporting-ui-components": "static-2.63701",
  "reporting-visualizations": "static-1.58506",
  "ui-addon-teams": "static-1.21209",
  "magpie-lib": "static-1.5372",
  "magpie-types": "static-1.4832",
  "simple-logging-lib": "static-1.2828",
  "navigation-components": "static-1.17205",
  "ai-studio-lib": "static-1.10943",
  "developer-experience-shared-components": "static-1.10246",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7762",
  "ui-tool-access": "static-1.9921",
  "usage-based-billing-components-lib": "static-1.7944",
  "usage-tracker-anonymous": "static-1.5527",
  "usage-tracker-public": "static-1.6921",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3485",
  "reference-resolvers": "static-1.7938",
  "ui-extensibility-client-types": "static-1.3725",
  "hubspot-apollo-cache": "static-1.116",
  "universal-page-editor-lib": "static-1.2775",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2132",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4848",
  "purchase-motions-components": "static-1.5451",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4285",
  "batch-promise": "static-1.1328",
  "crm-component-utils": "static-1.38443",
  "crm-properties-common-lib": "static-1.5649",
  "framework-data-schema-resolvers": "static-1.6648",
  "reference-resolvers-lite": "static-1.7868",
  "navigation-messaging": "static-1.6532",
  "hubspotter-http-shared-msw-handlers": "static-1.9427",
  "cms-field-types": "static-1.4583",
  "content-icons-ui": "static-1.2146",
  "conversations-skeleton-state": "static-1.7027",
  "crm-message-bus": "static-1.42295",
  "customer-data-filters-ui-msw-helpers": "static-1.21256",
  "customer-data-ui-utilities": "static-1.9601",
  "FormUrlGenerator": "static-2.4508",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6553",
  "multi-account-reference-resolvers": "static-1.748",
  "onboarding-tours": "static-1.16225",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12980",
  "academy-common-lib": "static-1.12889",
  "content-assistance-lib": "static-1.7416",
  "dashboard-lib": "static-1.80548",
  "file-manager-components": "static-1.22826",
  "getting-started-shared-tasks": "static-1.17827",
  "hubspot-prosemirror": "static-1.17554",
  "hubspot-prosemirror-plugins": "static-1.17546",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19433",
  "share-with-third-party-component-lib": "static-1.8469",
  "ui-addon-draggable": "static-3.4543",
  "ui-asset-management-lib": "static-1.10678",
  "ui-business-units-lib": "static-1.8803",
  "user-context": "static-1.4872",
  "growth-payments-core": "static-1.24672",
  "reporting-plugins": "static-1.9953",
  "reporting-reports": "static-1.66108",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.504",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28813",
  "react-codemirror": "static-1.10404",
  "apps-service-types": "static-1.3657",
  "oauth-service-types": "static-1.4019",
  "onboarding-scopes": "static-1.6241",
  "onboarding-tours-client": "static-1.4439",
  "platform-infra-nav-components": "static-1.7473",
  "subscription-experience-data-types": "static-1.14558",
  "crm-record-cards-service-types": "static-1.3432",
  "location-customization-utils-lib": "static-1.8499",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2134",
  "purchase-motions-api": "static-1.5454",
  "signup-constants": "static-1.18342",
  "signup-ui-url-generator": "static-2.7843",
  "trials-service-types": "static-1.3702",
  "card-properties-lib": "static-1.43465",
  "crm-actions": "static-1.6074",
  "crm-cards-data": "static-1.1165",
  "crm-cards-sdk": "static-1.42856",
  "customer-data-properties": "static-1.50743",
  "customer-data-properties-shared-msw-handlers": "static-1.8756",
  "customer-data-tracking": "static-1.6659",
  "conditional-properties-service-client": "static-1.3604",
  "crm-pipelines-api-client-types": "static-1.3944",
  "multi-currency-client-types": "static-1.3498",
  "external-options-client-types": "static-1.3964",
  "react-dnd-compat": "static-1.4400",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5129",
  "growth-onboarding-confetti": "static-1.2848",
  "growth-onboarding-next-action-utils": "static-1.1273",
  "onboarding-tours-utils": "static-1.291",
  "ui-shepherd-tracker": "static-1.7303",
  "academy-service-client": "static-1.3460",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27890",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8163",
  "video-components-external": "static-1.10503",
  "video-data-lib": "static-1.34161",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8347",
  "payment-link-components": "static-1.22888",
  "ui-addon-emoji-picker": "static-1.9666",
  "EmailSignatureEditor": "static-1.23862",
  "viral-links-lib": "static-1.6808",
  "data-token-picker": "static-1.16005",
  "FileManagerLib": "static-1.38466",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5022",
  "getting-started-shared-tasks-store": "static-1.16945",
  "campaign-roi-lib": "static-1.8214",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.169",
  "eligibility-engine-service-types": "static-1.2983",
  "crm_data": "static-4.91154",
  "crm-links": "static-1.6034",
  "customer-data-sidebar": "static-2.45362",
  "enrichment-properties-lib": "static-1.14920",
  "crm-fe-perf": "static-1.22684",
  "calling-global-api": "static-1.63586",
  "calling-internal-common": "static-1.31071",
  "calling-lifecycle-internal": "static-1.64968",
  "calling-lifecycle-messages": "static-1.57262",
  "commerce-products-lib": "static-1.8800",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.452",
  "inbounddb-objects-service-types": "static-1.4030",
  "meetings-icalendar-utils-lib": "static-1.411",
  "object-builder-ui-client": "static-1.47900",
  "pipeline-validation-client-types": "static-1.3766",
  "property-value-citations": "static-1.1357",
  "pulse": "static-1.284",
  "smart-property-lib": "static-1.5802",
  "tiered-pricing": "static-1.794",
  "ui-addon-form-validation": "static-1.10772",
  "growth-onboarding-feedback-components": "static-1.6363",
  "content-media-composition-data-lib": "static-1.11367",
  "content-media-compositions": "static-2.15374",
  "media-bridge-lib": "static-1.18527",
  "commerce-tours-lib": "static-1.5683",
  "growth-onboarding-reliability": "static-1.4866",
  "sales-checkout-service-client": "static-1.3456",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21271",
  "sales-email-signature-service-client": "static-1.3623",
  "audio-components": "static-1.5580",
  "FileManagerCore": "static-1.38325",
  "FileManagerImages": "static-1.35977",
  "video-components": "static-1.12506",
  "crm_universal": "static-1.21623",
  "customer-data-email": "static-1.17631",
  "calling-error-reporting": "static-1.31077",
  "card-payment-highlight-lib": "static-1.36452",
  "card-subscription-highlight-lib": "static-1.38806",
  "commerce-billing-lib": "static-1.18446",
  "commerce-contract-lib": "static-1.11086",
  "customer-data-content": "static-1.26835",
  "invoices-highlight-card-lib": "static-1.53949",
  "orders-highlight-card-lib": "static-1.20820",
  "products-highlight-card-lib": "static-1.17084",
  "project-storage": "static-1.4510",
  "quotes-highlight-card-lib": "static-1.71097",
  "breeze-intelligence-kit": "static-1.5288",
  "crm-source-interpretation-lib": "static-1.5106",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9512",
  "policy-lib": "static-1.6559",
  "shared-worker-versioning": "static-1.10814",
  "calling-usage-tracker": "static-1.6316",
  "voice-sms-access-library": "static-1.188",
  "products-iframe-lib": "static-1.7259",
  "products-ui-components-shared-msw-handlers": "static-1.9811",
  "directed-graph": "static-1.715",
  "event-emitter": "static-1.725",
  "react-tinymce": "static-1.54563",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9575",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53689",
  "tinymce-plugins": "static-1.56803",
  "tinymce-themes": "static-1.55659",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4312",
  "video-embed": "static-1.34995",
  "social-insights-client-types": "static-1.21265",
  "sequences-lib": "static-1.7653",
  "ui-gdpr-components": "static-1.10125",
  "commerce-shared-components-lib": "static-1.17858",
  "commerce-subscription-lib": "static-1.36383",
  "commerce-tools-ui-lib": "static-1.9742",
  "utility-belt": "static-1.2320",
  "payments-enrollment-embed-lib": "static-1.21932",
  "products-ui-components": "static-1.39319",
  "quotes-client-types": "static-1.37185",
  "quotes-ui-lib": "static-1.79816",
  "SalesContentIndexUI": "static-3.8867",
  "accounting-integrations-ui-components": "static-1.6688",
  "invoices-ui-lib": "static-1.53965",
  "commerce-products-api": "static-1.1924",
  "SafeStorage": "static-1.4182",
  "invoices-iframe-lib": "static-1.56023",
  "quotes-modal-lib": "static-1.101773",
  "calling-orchestration-schema": "static-1.34965",
  "sales-views-client-types": "static-1.4070",
  "hub-http-contrib": "static-1.2822",
  "interframe": "static-3.4569",
  "tinymce-data": "static-1.39774",
  "ui-addon-sales-email": "static-1.4991",
  "layout-dnd-components": "static-1.11990",
  "layout-dnd-utils": "static-1.10965",
  "ui-brand-identity-lib": "static-1.13758",
  "NamespacedHubStyle": "static-2.8876",
  "outpost": "static-1.3982",
  "sequences-client-types-lib": "static-1.7510",
  "customer-data-associations": "static-1.7113",
  "framework-data-table": "static-2.11360",
  "customer-data-rte": "static-1.32397",
  "cv-backend-services": "static-1.1491",
  "growth-onboarding-empty-states": "static-1.5330",
  "InboxConnectUtils": "static-4.14171",
  "payments-post-enroll-local-storage-lib": "static-1.4890",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7095",
  "commerce-permissions": "static-1.530",
  "commerce-tax-lib": "static-1.287",
  "property-description-translator": "static-1.3637",
  "FireAlarmUi": "static-1.4307",
  "sales-templates-service-types-lib": "static-1.3974",
  "commerce-analytics-service-client": "static-1.3444",
  "totals-ui-components": "static-1.22946",
  "ContentData": "static-1.67637",
  "layout-data-lib": "static-1.9290",
  "deal-intel-decorators": "static-1.1189",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27665",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3618",
  "advanced-menus-core": "static-1.14782",
  "advanced-menus-lib": "static-1.11762",
  "ui-memberships-settings-lib": "static-1.33373",
  "deal-intel-utils": "static-1.1193",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14781",
  "simple-menus-lib": "static-1.16298"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11498",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.213",
  "data-fetching-client": "/data-fetching-client/static-1.9456",
  "foundations-components": "/foundations-components/static-1.7483",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.508",
  "foundations-theming": "/foundations-theming/static-1.4187",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7783",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9429",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11201",
  "I18n": "/I18n/static-7.1562",
  "jasmine-runner": "/jasmine-runner/static-1.6250",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11558",
  "quartz": "/quartz/static-1.6694",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16419",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2640",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8363",
  "settings-ui-lib": "/settings-ui-lib/static-1.12298",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6685",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10910",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9326",
  "unified-auth": "/unified-auth/static-1.173",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.454",
  "usage-tracker": "/usage-tracker/static-1.7110",
  "usage-tracker-core": "/usage-tracker-core/static-1.6960",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7849",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15354",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18879",
  "property-management-iframe": "/property-management-iframe/static-1.12241",
  "quartz-config": "/quartz-config/static-1.472",
  "quartz-core": "/quartz-core/static-1.5913",
  "quartz-routing": "/quartz-routing/static-1.124",
  "quick-fetch": "/quick-fetch/static-1.3713",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4410",
  "ts-schema": "/ts-schema/static-1.3884",
  "ui-universal-auth": "/ui-universal-auth/static-1.8659",
  "UIComponents": "/UIComponents/static-3.8148",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3208",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2971",
  "quartz-webpack": "/quartz-webpack/static-1.2918",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3752",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4611",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1903",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9206",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5153",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1127",
  "ui-fonts": "/ui-fonts/static-1.463",
  "ui-images": "/ui-images/static-2.1085",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2670",
  "foundations-theming-base": "/foundations-theming-base/static-1.3172",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.704",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2894",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4107",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8294",
  "ai-rendering-library": "/ai-rendering-library/static-1.9236",
  "chirp-fetch": "/chirp-fetch/static-1.1662",
  "connections-embed-lib": "/connections-embed-lib/static-1.592",
  "copilot-toolkit": "/copilot-toolkit/static-1.10468",
  "laboratory-lib": "/laboratory-lib/static-3.6940",
  "marketplace-embed": "/marketplace-embed/static-1.21430",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8775",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18835",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13050",
  "sanitize-text": "/sanitize-text/static-1.7918",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8474",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5524",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4796",
  "wootric-nps": "/wootric-nps/static-1.6760",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4426",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3932",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2382",
  "reporting-data": "/reporting-data/static-1.66430",
  "cssUtils": "/cssUtils/static-1.725",
  "flux-actions": "/flux-actions/static-1.304",
  "HubStyle": "/HubStyle/static-2.11509",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9989",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10150",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7100",
  "icons": "/icons/static-2.618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17412",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4301",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4966",
  "quartz-i18n": "/quartz-i18n/static-1.369",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3509",
  "customer-data-objects": "/customer-data-objects/static-1.7422",
  "property-translator": "/property-translator/static-1.5191",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7702",
  "hs-promise-utils": "/hs-promise-utils/static-1.5369",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4657",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12769",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5363",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7566",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4252",
  "superstore": "/superstore/static-1.4549",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9922",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7382",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "hubspotter-http": "/hubspotter-http/static-1.4457",
  "immutable-less": "/immutable-less/static-1.4431",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16286",
  "nav-meta": "/nav-meta/static-1.28842",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10014",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17618",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3655",
  "property-management-common": "/property-management-common/static-1.4528",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8819",
  "dispatcher": "/dispatcher/static-1.131",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.369",
  "quartz-head": "/quartz-head/static-1.359",
  "quartz-test": "/quartz-test/static-1.369",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2921",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20225",
  "ContentUtils": "/ContentUtils/static-1.67562",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2263",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38822",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12782",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12919",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13429",
  "ExportDialog": "/ExportDialog/static-6.10166",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40608",
  "reporting-snowflake": "/reporting-snowflake/static-1.55048",
  "reporting-ui-components": "/reporting-ui-components/static-2.63701",
  "reporting-visualizations": "/reporting-visualizations/static-1.58506",
  "ui-addon-teams": "/ui-addon-teams/static-1.21209",
  "magpie-lib": "/magpie-lib/static-1.5372",
  "magpie-types": "/magpie-types/static-1.4832",
  "simple-logging-lib": "/simple-logging-lib/static-1.2828",
  "navigation-components": "/navigation-components/static-1.17205",
  "ai-studio-lib": "/ai-studio-lib/static-1.10943",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10246",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7762",
  "ui-tool-access": "/ui-tool-access/static-1.9921",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7944",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5527",
  "usage-tracker-public": "/usage-tracker-public/static-1.6921",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3485",
  "reference-resolvers": "/reference-resolvers/static-1.7938",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3725",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.116",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2775",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2132",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4848",
  "purchase-motions-components": "/purchase-motions-components/static-1.5451",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4285",
  "batch-promise": "/batch-promise/static-1.1328",
  "crm-component-utils": "/crm-component-utils/static-1.38443",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5649",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6648",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7868",
  "navigation-messaging": "/navigation-messaging/static-1.6532",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9427",
  "cms-field-types": "/cms-field-types/static-1.4583",
  "content-icons-ui": "/content-icons-ui/static-1.2146",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7027",
  "crm-message-bus": "/crm-message-bus/static-1.42295",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21256",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9601",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4508",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6553",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.748",
  "onboarding-tours": "/onboarding-tours/static-1.16225",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12980",
  "academy-common-lib": "/academy-common-lib/static-1.12889",
  "content-assistance-lib": "/content-assistance-lib/static-1.7416",
  "dashboard-lib": "/dashboard-lib/static-1.80548",
  "file-manager-components": "/file-manager-components/static-1.22826",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17827",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17554",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17546",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19433",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8469",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4543",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10678",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8803",
  "user-context": "/user-context/static-1.4872",
  "growth-payments-core": "/growth-payments-core/static-1.24672",
  "reporting-plugins": "/reporting-plugins/static-1.9953",
  "reporting-reports": "/reporting-reports/static-1.66108",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.504",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28813",
  "react-codemirror": "/react-codemirror/static-1.10404",
  "apps-service-types": "/apps-service-types/static-1.3657",
  "oauth-service-types": "/oauth-service-types/static-1.4019",
  "onboarding-scopes": "/onboarding-scopes/static-1.6241",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4439",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7473",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14558",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3432",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8499",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2134",
  "purchase-motions-api": "/purchase-motions-api/static-1.5454",
  "signup-constants": "/signup-constants/static-1.18342",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7843",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "card-properties-lib": "/card-properties-lib/static-1.43465",
  "crm-actions": "/crm-actions/static-1.6074",
  "crm-cards-data": "/crm-cards-data/static-1.1165",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42856",
  "customer-data-properties": "/customer-data-properties/static-1.50743",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8756",
  "customer-data-tracking": "/customer-data-tracking/static-1.6659",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3604",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3944",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3498",
  "external-options-client-types": "/external-options-client-types/static-1.3964",
  "react-dnd-compat": "/react-dnd-compat/static-1.4400",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5129",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2848",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1273",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.291",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7303",
  "academy-service-client": "/academy-service-client/static-1.3460",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27890",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8163",
  "video-components-external": "/video-components-external/static-1.10503",
  "video-data-lib": "/video-data-lib/static-1.34161",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8347",
  "payment-link-components": "/payment-link-components/static-1.22888",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9666",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23862",
  "viral-links-lib": "/viral-links-lib/static-1.6808",
  "data-token-picker": "/data-token-picker/static-1.16005",
  "FileManagerLib": "/FileManagerLib/static-1.38466",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5022",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16945",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8214",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.169",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "crm_data": "/crm_data/static-4.91154",
  "crm-links": "/crm-links/static-1.6034",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45362",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14920",
  "crm-fe-perf": "/crm-fe-perf/static-1.22684",
  "calling-global-api": "/calling-global-api/static-1.63586",
  "calling-internal-common": "/calling-internal-common/static-1.31071",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64968",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57262",
  "commerce-products-lib": "/commerce-products-lib/static-1.8800",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.452",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4030",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.411",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47900",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3766",
  "property-value-citations": "/property-value-citations/static-1.1357",
  "pulse": "/pulse/static-1.284",
  "smart-property-lib": "/smart-property-lib/static-1.5802",
  "tiered-pricing": "/tiered-pricing/static-1.794",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10772",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6363",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11367",
  "content-media-compositions": "/content-media-compositions/static-2.15374",
  "media-bridge-lib": "/media-bridge-lib/static-1.18527",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5683",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4866",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3456",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21271",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3623",
  "audio-components": "/audio-components/static-1.5580",
  "FileManagerCore": "/FileManagerCore/static-1.38325",
  "FileManagerImages": "/FileManagerImages/static-1.35977",
  "video-components": "/video-components/static-1.12506",
  "crm_universal": "/crm_universal/static-1.21623",
  "customer-data-email": "/customer-data-email/static-1.17631",
  "calling-error-reporting": "/calling-error-reporting/static-1.31077",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36452",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38806",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18446",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11086",
  "customer-data-content": "/customer-data-content/static-1.26835",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53949",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20820",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17084",
  "project-storage": "/project-storage/static-1.4510",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71097",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5288",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5106",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9512",
  "policy-lib": "/policy-lib/static-1.6559",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10814",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6316",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.188",
  "products-iframe-lib": "/products-iframe-lib/static-1.7259",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9811",
  "directed-graph": "/directed-graph/static-1.715",
  "event-emitter": "/event-emitter/static-1.725",
  "react-tinymce": "/react-tinymce/static-1.54563",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9575",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53689",
  "tinymce-plugins": "/tinymce-plugins/static-1.56803",
  "tinymce-themes": "/tinymce-themes/static-1.55659",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4312",
  "video-embed": "/video-embed/static-1.34995",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "sequences-lib": "/sequences-lib/static-1.7653",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10125",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17858",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36383",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9742",
  "utility-belt": "/utility-belt/static-1.2320",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21932",
  "products-ui-components": "/products-ui-components/static-1.39319",
  "quotes-client-types": "/quotes-client-types/static-1.37185",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79816",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8867",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6688",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53965",
  "commerce-products-api": "/commerce-products-api/static-1.1924",
  "SafeStorage": "/SafeStorage/static-1.4182",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56023",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101773",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34965",
  "sales-views-client-types": "/sales-views-client-types/static-1.4070",
  "hub-http-contrib": "/hub-http-contrib/static-1.2822",
  "interframe": "/interframe/static-3.4569",
  "tinymce-data": "/tinymce-data/static-1.39774",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4991",
  "layout-dnd-components": "/layout-dnd-components/static-1.11990",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10965",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13758",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8876",
  "outpost": "/outpost/static-1.3982",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7510",
  "customer-data-associations": "/customer-data-associations/static-1.7113",
  "framework-data-table": "/framework-data-table/static-2.11360",
  "customer-data-rte": "/customer-data-rte/static-1.32397",
  "cv-backend-services": "/cv-backend-services/static-1.1491",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5330",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14171",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4890",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7095",
  "commerce-permissions": "/commerce-permissions/static-1.530",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.287",
  "property-description-translator": "/property-description-translator/static-1.3637",
  "FireAlarmUi": "/FireAlarmUi/static-1.4307",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3974",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3444",
  "totals-ui-components": "/totals-ui-components/static-1.22946",
  "ContentData": "/ContentData/static-1.67637",
  "layout-data-lib": "/layout-data-lib/static-1.9290",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1189",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27665",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3618",
  "advanced-menus-core": "/advanced-menus-core/static-1.14782",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11762",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33373",
  "deal-intel-utils": "/deal-intel-utils/static-1.1193",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14781",
  "simple-menus-lib": "/simple-menus-lib/static-1.16298"
}
};
